import { render, staticRenderFns } from "./WorkloadTableActions.vue?vue&type=template&id=53f51b45&scoped=true"
import script from "./WorkloadTableActions.vue?vue&type=script&lang=js"
export * from "./WorkloadTableActions.vue?vue&type=script&lang=js"
import style0 from "./WorkloadTableActions.vue?vue&type=style&index=0&id=53f51b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f51b45",
  null
  
)

export default component.exports